import { Component, OnInit } from '@angular/core';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ProductSettings } from '@models/domain/product.settings';

@Component({
    selector: 'sales-product-settings',
    templateUrl: './sales.product.settings.component.html',
    styleUrls: ['./sales.product.settings.component.scss']
})
export class SalesProductSettingsComponent implements OnInit {

    // VARIABLES
    IsBusy: boolean = false;
  
    VIP3D: ProductSettings = new ProductSettings();
    VIP3DSpecial: ProductSettings = new ProductSettings();
    VizTerra: ProductSettings = new ProductSettings();
    PoolStudio: ProductSettings = new ProductSettings();

    constructor(private sweetAlert: SweetAlertService, private api: ssApiService, private gb: GlobalService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Product Settings');

        // get products
        var disposable = this.api.GetStructureStudiosProductsSettings().subscribe(response  =>  
        {
            console.log(response);
            disposable.unsubscribe();

            if (response.Result == false){
                return;
            }

            var products = response.Data;
            
            this.VizTerra = products.find(x=>x.ID == 1);
            this.PoolStudio = products.find(x=>x.ID == 2);
            this.VIP3D = products.find(x=>x.ID == 3);
            this.VIP3DSpecial = products.find(x=>x.ID == 4); 

            console.log("VizTerra", this.VizTerra);
            console.log("Pool Studio", this.PoolStudio);
            console.log("VIP3D", this.VIP3D);
            console.log("VIP3D Special", this.VIP3DSpecial);
            console.log("VIP3D Addons", this.VIP3D.Addons);

        });           
            
    }

    public SaveVIP3D()
    {
        this.Save(this.VIP3D);        
    }

    public SaveVIP3DSpecial()
    {
        this.Save(this.VIP3DSpecial);        
    }

    public SavePoolStudio()
    {
        this.Save(this.PoolStudio);        
    }

    public SaveVizTerra()
    {
        this.Save(this.VizTerra);        
    }

    public Save(product: ProductSettings)
    {
        console.log("Save Product " + product.Name, product);

        var title = 'Editing Public Settings For ' + product.Name;
        var question = 'Are you sure you want to edit ' + product.Name + ' settings? These changes are public and live!'

        this.sweetAlert.swal({
            type: 'warning',
            title: title,
            text: question,
            showCancelButton: true
        }).then((response) => {
            this.IsBusy = true;

            let disposable = this.api.SaveStructureStudiosProductSettings(product).subscribe(response => 
                {
                    disposable.unsubscribe();
                    this.IsBusy = false;  

                    if (!response.Result)
                    {
                        // Error
                        this.sweetAlert.swal({
                                    type: 'error',
                                    title: "Error",
                                    text: response.Data,
                                    showCancelButton: false
                                })
                                .then((response) => {return;});
                    
                        return;
                    }

                    // OK                    
                    this.sweetAlert.swal({
                        type: 'success',
                        title: "Saved",
                        text:  "The changes are saved",
                        showCancelButton: false
                    })
                    .then((response) => {return;});
                      
                });

                   
            
        }, (dismiss) => {
            this.IsBusy = false;
        });
    }

}
